// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_l72a2"};